export default __webpack_public_path__ + "static/media/V470_SOV.995b3722.pdf";